import { Navigation } from '../../types';
import brand from './links/brand.json';
import explore from './links/explore.json';
import info from './links/info.json';
import help from './links/help.json';
import appStores from './appStores/appStores.json';
import socialMedia from './socialMedia/socialMedia.json';

const defaultNavigation: Navigation = {
  links: [brand, explore, info, help],
  appStores,
  socialMedia
} as Navigation;

export default defaultNavigation;
